import React from 'react';
import { useDashboardContext } from './DashboardContext';
import { formatMoney } from './helpers';

const QuickPill: React.FC<{
  title: string;
  value: string | number;
  color: string;
}> = ({ title, value, color }) => (
  <div className="flex flex-col items-center justify-center rounded-xl border border-slate-100 bg-slate-50 p-2.5 text-center">
    <span className="text-[9px] uppercase tracking-wider text-slate-500">
      {title}
    </span>
    <span className={`mt-0.5 text-[13px] font-bold ${color}`}>{value}</span>
  </div>
);

export const QuickStatsCard: React.FC = () => {
  const { dashboard } = useDashboardContext();
  return (
    <div className="flex flex-col rounded-[22px] border border-slate-100 bg-white p-4 shadow-[0_2px_8px_rgba(0,0,0,0.02)] lg:col-span-1">
      <h3 className="mb-3 text-[13px] font-semibold text-slate-900">
        Quick Stats
      </h3>
      <div className="grid flex-1 grid-cols-2 gap-2">
        <QuickPill
          title="Bills"
          value={dashboard.summary.billsSettled}
          color="text-slate-900"
        />
        <QuickPill
          title="Credit"
          value={formatMoney(dashboard.summary.creditIssued)}
          color="text-rose-600"
        />
        <QuickPill
          title="NC"
          value={formatMoney(dashboard.summary.ncIssued)}
          color="text-amber-600"
        />
        <QuickPill
          title="Activity"
          value={dashboard.summary.settlementCount}
          color="text-emerald-600"
        />
      </div>
    </div>
  );
};
